export const SET_MATERIAL_BILLS = "SET_MATERIAL_BILLS";
